import { useState } from "react";
import { IListItem } from "../components/UI/customSelect/CustomSelect";

export function useSelect() {
  const [selected, setSelected] = useState({} as IListItem)

  function handleSelect(option: IListItem) {
    setSelected(option)
  }

  return { selected, handleSelect }
}